module.exports = __webpack_public_path__ + "static/media/ic_nav_03_selected.e0d9f850.svg";